/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bookmarks{border:1px solid #a9a9a9;overflow-y:auto;height:85%}.bookmark{padding:7px}.bookmark:hover{background:#efefef}.icon:hover{cursor:pointer;color:#888}.create-container{height:20%}.catalog-container{height:80%}"];
export { styles as styles };
